const doc =  document;
const documentElement = doc.documentElement;
const now = Date.now();

/**
 * Creates and returns a DOM element
 * @param {string} tag Name of tag to create
 * @param {Record<string, string>} attrs Object containing attributes to be added to the node
 * @returns Element
 */
const createElement = (tag, attrs) => Object.entries(attrs).reduce(
  (node, [key, value]) => {
    node.setAttribute(key, value);
    return node;
  },
  doc.createElement(tag)
);

/**
 * Return the given url with no fragment
 * @param {string} url potentially containing a fragment
 * @return {string} url without fragment
 */
 const removeUrlFragment = url => url.split('#')[0];

/**
 * Removes search params from the URL, if any
 */
const removeSearchParams = () => {
  if (!location.search) return;

  const a = createElement('a', { href: location.href });
  a.search = '';
  history.replaceState(null, null, a.href);
}

/**
 * Injects a script into document.head
 * @param {string} src path of script to be injected in <head>
 * @return {Promise} Promise object that resolves on script load event
 */
 const dynamicScriptInject = src => new Promise(resolve => {
  const script = createElement('script', { src, type: 'text/javascript' });
  doc.head.appendChild(script);
  script.addEventListener('load', resolve);
});


const prefetchCache = new Set();
/**
 * Prefetches a link's HTML page
 * @param {Event} e Link mouseOver / touchStart event
 * @returns 
 */
const prefetch = e => {
  if (e.target.tagName != "A") return;
  if (e.target.origin != location.origin) return;
  const cleanedUpHref = removeUrlFragment(e.target.href)
  if (removeUrlFragment(window.location.href) === cleanedUpHref) return;
  if (prefetchCache.has(cleanedUpHref)) return;

  prefetchCache.add(cleanedUpHref);
  doc.head.appendChild(createElement('link', {
    rel: 'prefetch',
    href: e.target.href
  }));
}

/**
 * Sets up the prefetching of links
 */
const setupPrefetch = () => {
  const eventDetails = {
    capture: true,
    passive: true,
  };

  documentElement.addEventListener('mouseover', prefetch, eventDetails);
  documentElement.addEventListener('touchstart', prefetch, eventDetails);
};

const setupGoogleAnalytics = () => {
  const GA_ID = documentElement.getAttribute('ga-id');
  window.ga = window.ga || function () {
    if (!GA_ID) return;
    (ga.q = ga.q || []).push(arguments);
  };
  ga.l = now;
  ga('create', GA_ID, 'auto');
  ga('set', 'transport', 'beacon');
}

const logPageViewToGA = () => {
  let timeout = setTimeout(() => {
    clearTimeout(timeout);
    ga('send', 'pageview');
  }, 1000);
}

const setupVisibilityChangeLogging = () => {
  let ref = now;
  const ping = event => {
    const now = +new Date();
    if (now - ref < 1000) return;
  
    ga('send', {
      hitType: 'event',
      eventCategory: 'page',
      eventAction: event.type,
      eventLabel: Math.round((now - ref) / 1000),
    });
    ref = now;
  }
  addEventListener('pagehide', ping);
  addEventListener('visibilitychange', ping);
}

// Script web-vitals.js will be injected dynamically if user opts-in to sending CWV data.
// const sendWebVitals = doc.currentScript.getAttribute('data-cwv-src');

// if (/web-vitals.js/.test(sendWebVitals)) {
//   dynamicScriptInject(`${window.location.origin}/js/web-vitals.js`)
//   .then(() => {
//     webVitals.getCLS(sendToGoogleAnalytics);
//     webVitals.getFID(sendToGoogleAnalytics);
//     webVitals.getLCP(sendToGoogleAnalytics);
//   })
//   .catch(console.error);
// }

// addEventListener("click", e => {
//     var button = e.target.closest("button");
//     if (!button) return;

//     ga("send", {
//       hitType: "event",
//       eventCategory: "button",
//       eventAction: button.getAttribute("aria-label") || button.textContent,
//     });
//   },
//   true
// );

// var selectionTimeout;
// addEventListener("selectionchange", () => {
//     clearTimeout(selectionTimeout);
//     var text = String(doc.getSelection()).trim();
//     if (text.split(/[\s\n\r]+/).length < 3) {
//       return;
//     }
//     selectionTimeout = setTimeout(function () {
//       ga("send", {
//         hitType: "event",
//         eventCategory: "selection",
//         eventAction: text,
//       });
//     }, 2000);
//   },
//   true
// );

// if (window.ResizeObserver && doc.querySelector("header nav #nav")) {
//   var progress = doc.getElementById("reading-progress");

//   var timeOfLastScroll = 0;
//   var requestedAniFrame = false;
//   function scroll() {
//     if (!requestedAniFrame) {
//       requestAnimationFrame(updateProgress);
//       requestedAniFrame = true;
//     }
//     timeOfLastScroll = Date.now();
//   }
//   addEventListener("scroll", scroll);

//   var winHeight = 1000;
//   var bottom = 10000;
//   function updateProgress() {
//     requestedAniFrame = false;
//     var percent = Math.min(
//       (doc.scrollingElement.scrollTop / (bottom - winHeight)) * 100,
//       100
//     );
//     progress.style.transform = `translate(-${100 - percent}vw, 0)`;
//     if (Date.now() - timeOfLastScroll < 3000) {
//       requestAnimationFrame(updateProgress);
//       requestedAniFrame = true;
//     }
//   }

//   new ResizeObserver(() => {
//     bottom =
//       doc.scrollingElement.scrollTop +
//       doc.querySelector("#comments,footer").getBoundingClientRect().top;
//     winHeight = window.innerHeight;
//     scroll();
//   }).observe(doc.body);
// }

/**
 * There is a race condition here if an image loads faster than this JS file. But
 * - that is unlikely
 * - it only means potentially more costly layouts for that image.
 * - And so it isn't worth the querySelectorAll it would cost to synchronously check
 *   load state.
 */
const setupImageBlurEffect = () => {
  doc.body.addEventListener("load", e => {
      if (e.target.tagName != "IMG") {
        return;
      }
      // Ensure the browser doesn't try to draw the placeholder when the real image is present.
      e.target.style.backgroundImage = "none";
    },
    /* capture */ "true"
  );
}

removeSearchParams();
setupPrefetch();
setupGoogleAnalytics();
logPageViewToGA();
setupVisibilityChangeLogging();
setupImageBlurEffect();
